export default __webpack_public_path__ + "static/media/kanta_portrait.d18ba44e.jpg";